import { h, Component, ComponentChild } from 'preact'
import Icon from '../../preact-components/assets'

interface State {
  isVisible: boolean
  isVisibleFor?: number | null | false
}

interface Props {
  messageType?: string | null
  isVisible?: boolean
  renderHTML?: boolean
  sticky?: boolean
  children?: ComponentChild
  message?: string | null
  onClose?: () => void
  isVisibleFor?: number | null | false
  onTimeoutEnd?: () => void
}

class AlertComponent extends Component<Props, State> {
  private timeout: number

  constructor (props: Props) {
    super()
    this.timeout = 0
    this.state = {
      isVisible: props.isVisible || true,
      isVisibleFor: props.isVisibleFor
    }
  }

  componentDidMount () {
    if (this.state.isVisible && this.state.isVisibleFor) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() =>
        this.setState({ isVisible: false }, () => {
          if (this.props.onTimeoutEnd) {
            this.props.onTimeoutEnd()
          }
        }), this.state.isVisibleFor)
    }
  }

  componentDidUpdate (prevProps: Readonly<Props>) {
    if (this.props.isVisible !== prevProps.isVisible && this.props.isVisible) {
      this.setState({ isVisible: this.props.isVisible })
    }
  }

  onClose () {
    this.setState({ isVisible: false })

    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  render ({ messageType, sticky, children, message, renderHTML }: Props, state: State) {
    if (messageType === null) {
      return null
    }

    let type, defaultMessage
    switch (messageType) {
      case 'error': type = 'danger'
        defaultMessage = 'Changes could not be applied'
        break
      case 'success': type = 'success'
        defaultMessage = 'Changes applied successfully!'
        break
      default: type = messageType || ''
        defaultMessage = ''
    }

    const attributes = {
      role: 'alert',
      className: `alert-notification alert alert-${type} box--alert box__pad`
    }

    if (sticky) attributes.className += ' sticky-top'

    return (
      <div
        {...!state.isVisible && { style: { display: 'none' } }}
        {...attributes}
      >
        {
          Array(children).toString() !== ''
            ? children
            : (
              <div dangerouslySetInnerHTML={renderHTML && message ? { __html: message } : undefined}>
                {message || defaultMessage}
              </div>
              )
        }
        <Icon icon='close' customClass='alert-notification__close' onClick={() => this.onClose()} />
      </div>
    )
  }
}

export default AlertComponent
